
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 60 60"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"29.583","cy":"29.583","r":"28.738","fill":"#fff","stroke":"#232D37","stroke-width":"1.69"}}),_c('g',{attrs:{"clip-path":"url(#devices_svg__clip0)","fill-rule":"evenodd","clip-rule":"evenodd","fill":"#161E27"}},[_c('path',{attrs:{"d":"M26.53 39.049a1.98 1.98 0 001.8 1.14h14.616c.65 0 1.268-.27 1.706-.742l.37-.398H26.53zm18.491-2.281c.916 0 1.746.533 2.115 1.36.37.828.21 1.793-.409 2.46l-.37.398a4.651 4.651 0 01-3.41 1.484H28.328c-1.655 0-3.16-.94-3.87-2.41a2.247 2.247 0 01-.24-1.011c0-1.26 1.035-2.281 2.311-2.281v-9.124c0-1.89 1.552-3.422 3.467-3.422h11.557c1.915 0 3.467 1.532 3.467 3.422v9.124zm-16.18 0H42.71v-9.124c0-.63-.517-1.14-1.156-1.14H29.997c-.638 0-1.155.51-1.155 1.14v9.123z"}}),_c('path',{attrs:{"d":"M13.523 31.541v-8.493c0-1.759 1.481-3.185 3.308-3.185h15.435c1.74 0 3.168 1.296 3.298 2.94h-2.225a1.095 1.095 0 00-1.073-.817H16.83c-.609 0-1.103.476-1.103 1.062v8.493c0 .587.494 1.062 1.103 1.062h7.718v3.338c-1.218 0-2.205 1.07-2.205 2.389 0 .223.028.438.08.643h-2.286c-.609 0-1.102-.475-1.102-1.062 0-.586.493-1.061 1.102-1.061h1.103v-2.124h-4.41c-1.827 0-3.308-1.426-3.308-3.185z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"devices_svg__clip0"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(13.523 13.524)","d":"M0 0h33.809v33.809H0z"}})])])])
          )
        }
      }
    